var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValuesBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 515,
    height: 501,
    viewBox: "0 0 515 501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "73hkw9cbsa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0H515V501H0z",
    transform: "translate(0 267)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#73hkw9cbsa)",
    transform: "translate(0 -267)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M437 331h-17.763a44.733 44.733 0 0 0-84.474 0H302a30 30 0 0 1 0-60h105c4.856 0 9.96-3.276 12-6.006l72.041-97.035a105.006 105.006 0 1 0-168.076-.015L377.007 241H302a60 60 0 0 0 0 120h32.763a44.733 44.733 0 0 0 84.474 0H437a45.05 45.05 0 0 1 45 45c0 24.814-20.186 46-45 46H329.237a44.733 44.733 0 0 0-84.474 0H135l54.038-73.041A105 105 0 1 0 0 316a104.063 104.063 0 0 0 20.962 62.944c1.746 2.328 72.375 97.9 74.6 99.73a15.153 15.153 0 0 0 9.423 3.326h139.778a44.733 44.733 0 0 0 84.474 0H437c41.353 0 75-34.647 75-76a75.087 75.087 0 0 0-75-75zm-75-226a45 45 0 1 1 45 45 45.05 45.05 0 0 1-45-45zM105 361a45 45 0 1 1 45-45 45.05 45.05 0 0 1-45 45z",
    transform: "translate(-97 284)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M407 90a15 15 0 1 0 15 15 15.011 15.011 0 0 0-15-15z",
    transform: "translate(-97 284)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M105 301a15 15 0 1 0 15 15 15.011 15.011 0 0 0-15-15z",
    transform: "translate(-97 284)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuesBg);
export default __webpack_public_path__ + "static/media/valuesBg.afe38c96b0f2b82c4aee2bfe25693d15.svg";
export { ForwardRef as ReactComponent };